export const pluralizeNum = (val) => (val === 1 ? "" : "s");
